import * as React from 'react';
import './styles.scss';
import { getCookie, setCookie } from '../../utils/Cookie';

export const CookiesAgreePopup = () => {
  const [show, setShow] = React.useState(false);
  React.useEffect(() => {
    if (!getCookie('acceptCookies')) {
      setShow(true);
    }
  }, []);

  return (
    <div className={`cookiealert ${show && 'show'}`}>
      <p>Мы используем файлы cookie. Вы не пpотив?</p>
      <button
        className="acceptcookies"
        onClick={() => {
          setCookie('acceptCookies', true, 365);
          setShow(false);
        }}
      >
        ОК
      </button>
    </div>
  );
};
